export const concealEmail = (email: string) => {
  // E.g. `pat+14@nanameue.jp` → `p****4@n*********p`.
  return email
    ?.split?.('@')
    ?.map?.((x) =>
      x
        ?.split?.('')
        ?.map?.((y, j, _self) => (j == 0 || j == _self?.length - 1 ? y : '*'))
        ?.join?.('')
    )
    ?.join?.('@')
}
